export const QUICKACTIONS = [
  {
    title: 'Create a business',
    subtitle:
      'Bizedge gives you the tools you need to manage all your business operations, you can create as many business account as you want.',
    action: 'Create a business',
    path: '/profile/add-company',
    panel: 'panel1',
    name: 'created_business'
  },
  {
    title: 'Invite users',
    subtitle:
      'Bizedge is an all in one business tool that cuts across various arms of your business operations. Add your colleagues to take charge.',
    action: 'Add users',
    path: '/settings?tab=add-user',
    panel: 'panel2',
    name: 'invited_users'
  },
  {
    title: 'Add your employees',
    subtitle:
      'People are the core of every organisation, Bizedge enables an inclusive people culture',
    action: 'Add an employee',
    path: '/add-employee-new?mode=fast',
    panel: 'panel3',
    name: 'added_employees'
  },
  {
    title: 'Setup Payroll',
    subtitle:
      'Let Bizedge run your next payroll. Its seamless and helps you get the job done faster',
    action: 'Continue to setup payroll',
    path: '/payroll/prepare-payroll',
    panel: 'panel4',
    name: 'setup_payroll'
  },
  {
    title: 'Time-Off Policy',
    subtitle: 'Give your employees the flexibility that PTO provides.',
    action: 'Setup time-off policy',
    path: '/hr?type=all-employees&tab=all-employee-time-off',
    panel: 'panel5',
    name: 'added_timeoff_policy'
  },
  {
    title: 'Add Assets',
    subtitle:
      "Keep track of all your company's asset in one asset register. Attach receipt and assigne asset to your employees.",
    action: 'Add asset',
    path: '/assets?tab=add-asset',
    panel: 'panel6',
    name: 'added_assets'
  },
  {
    title: 'Add Vehicles',
    subtitle:
      'Track and manage your company vehicles. Get reminders on due repairs and statutory documents.',
    action: 'Add vehicles',
    path: '/fleet?tab=add-vehicle',
    panel: 'panel7',
    name: 'added_vehicles'
  }
];
